import get from 'lodash.get';
import { useState } from 'react';

import { FM_ACTIONS } from '../../../utils/UtilFunctions';
import { handleTrack } from '../../../utils/tracker';
import { MarktechModal } from '../../Atoms/Modal';
import { tnc } from './tnc';

interface IOfferCard {
  date: string;
  image: string;
  title: string;
  description: string;
  brand: string;
}
export const SecondFoldOffer: React.FC<IOfferCard> = ({
  date,
  image,
  title,
  description,
  brand,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <div className="w-1/2 p-2 md:w-full sm:w-full">
        <button
          onClick={() => {
            setIsOpen(true);
            handleTrack({
              label: 'reward_card',
              action: FM_ACTIONS.click,
            });
          }}
          className="flex items-center p-4 border-sm border-grey-300 rounded-lg relative w-full focus:outline-none"
        >
          <div className="w-28 h-28">
            <img
              width={118}
              height={118}
              src={image}
              alt="icon"
              className="object-contain w-full h-full"
            />
          </div>
          <div className="pl-10 w-3/4">
            <div className="flex items-center">
              <p className="text-s-24 text-left font-bold text-[#FF4E01] sm:text-s-20 sm:pt-5">
                {title}
              </p>
            </div>
            <p className="text-base text-[#383838] text-left">{description}</p>
            <div className="font-medium text-s-12 text-blue-350 hover:text-blue-450 text-left mt-2">
              T&C’s Apply
            </div>
          </div>
          <div className="absolute top-0 right-4 py-2 px-6 rounded-b-md bg-[#4996FC] flex items-center justify-center sm:py-1 sm:px-4">
            <p className="text-base font-bold text-white sm:text-s-14">
              {date}
            </p>
          </div>
        </button>
      </div>
      <MarktechModal
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        closeIcon={'✕'}
        center
        classNames={{
          modal: 'w-1/2 mobile-search-box rounded-2xl sm:w-full sm:max-h-[90%]',
        }}
      >
        <div className="overflow-y-auto p-10 sm:p-5">
          <p className="text-font-500 text-center text-s-24 font-bold">
            Terms & Conditions
          </p>
          <div className="pt-10">{get(tnc, `${brand}`, <></>)}</div>
        </div>
      </MarktechModal>
    </>
  );
};
